import { Wave } from 'src/types/Wave';

export interface IBuyerPersonasState {
  buyerPersonas: BuyerPersona[];
}

export default function (): IBuyerPersonasState {
  return {
    buyerPersonas: [
      {
        //Affluent Traveller
        name: 'Affluent Traveller',
        photo: 'vip',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          plannings: { 8: [4, 5, 6, 7, 8, 9] }
        }
      },
      {
        //Affluent Premium Traveller
        name: 'Affluent Premium Traveller',
        photo: 'highvalue',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          plannings: {
            8: [5, 6, 7, 8, 9]
          }
        }
      },
      {
        //Cultural & Adventure Enthusiast
        name: 'Cultural & Adventure Enthusiast',
        photo: 'cultural-enthusiast',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          catalysts: {
            148: [4, 5],
            167: [4, 5]
          }
        }
      },
      {
        //Cultural & Adventure Fanatic
        name: 'Cultural & Adventure Fanatic',
        photo: 'cultural-fanatic',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          catalysts: {
            148: [4, 5],
            167: [4, 5]
          },
          behaviours: {
            4022: [7]
          }
        }
      },
      {
        //Sun, seaside & beach relaxing traveller
        name: 'Sun, Seaside & beach relaxing traveller',
        photo: 'beach',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [6]
          },
          catalysts: {
            137: [4, 5]
          }
        }
      },
      {
        //Sun, seaside & beach active traveller
        name: 'Sun, Seaside & beach active traveller',
        photo: 'beach-active',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          catalysts: {
            137: [4, 5],
            148: [4, 5]
          }
        }
      },
      {
        //Sport tourism
        name: 'Sport tourism',
        photo: 'sport-tourism',
        ignore: {
          since: Wave.Year2022B
        },
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [2, 22, 23, 30, 31]
          }
        }
      },
      {
        //Ski
        name: 'Ski',
        photo: 'ski',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [2]
          }
        }
      },
      {
        //Golf
        name: 'Golf',
        photo: 'golf',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: { 4022: [3] }
        }
      },
      {
        //Dive
        name: 'Dive',
        photo: 'dive',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: { 4022: [4] }
        }
      },
      {
        //Cycling
        name: 'Cycling',
        photo: 'cycling',
        ignore: {
          since: Wave.Year2022B
        },
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [27]
          }
        }
      },
      {
        //Hiker
        name: 'Hiker',
        photo: 'hiker',
        ignore: {
          since: Wave.Year2022B
        },
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [26]
          }
        }
      },
      {
        //Outdoor experiences enthusiast
        name: 'Outdoor experiences enthusiast',
        photo: 'outdoor',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          catalysts: {
            133: [4, 5]
          }
        }
      },
      {
        //Foodie traveller Enthusiast
        name: 'Foodie traveller Enthusiast',
        photo: 'foodie-enthusiast',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          catalysts: {
            140: [4, 5]
          }
        }
      },
      {
        //Foodie traveller Fanatic
        name: 'Foodie traveller Fanatic',
        photo: 'foodie-fanatic',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [19]
          },
          catalysts: {
            140: [4, 5]
          }
        }
      },
      {
        //Digital nomad
        name: 'Digital nomad',
        photo: 'independent',
        ignore: {
          since: Wave.Year2022A
        },
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [23]
          }
        }
      },
      {
        //Bleisure
        name: 'Bleisure',
        photo: 'bleisure',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [21]
          }
        }
      },
      {
        //Group
        name: 'Group',
        photo: 'group',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [10]
          }
        }
      },
      {
        //Environment Conscious Traveller
        name: 'Environment Conscious Traveller',
        photo: 'environment',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          enablers: {
            128: [4, 5]
          }
        }
      },
      {
        //Cruise Fanatic
        name: 'Cruise Fanatic',
        photo: 'cruise',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [8]
          }
        }
      },
      {
        //City Urban Explorer Enthusiast
        name: 'City Urban Explorer Enthusiast',
        photo: 'city',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          catalysts: {
            150: [4, 5]
          }
        }
      },
      {
        //City Urban Explorer
        name: 'City Urban Explorer',
        photo: 'city-fanatic',
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          behaviours: {
            4022: [11]
          },
          catalysts: {
            150: [4, 5]
          }
        }
      },
      {
        //Backpacker
        name: 'Backpacker',
        photo: 'backpacker',
        ignore: {
          since: Wave.Year2022B
        },
        filters: {
          year: [Wave.Year2025B],
          multiple: true,
          enablers: {
            170: [4, 5]
          }
        }
      }
    ]
  };
}
